// BOOTSTRAP APLIKACJI
export const API_BOOTSTRAP = 'bootstrap';

// AUTORYZACJA
export const API_AUTH_LOGIN = 'auth/login';
export const API_AUTH_LOGOUT = 'auth/logout';
export const API_AUTH_PROFILE = 'auth/profile';

// DASHBOARD
export const API_DASHBOARD_ADMIN_INFO = 'dashboard/admin';
export const API_DASHBOARD_USER_INFO = 'dashboard/user';

// DANE DO SELECTOW
export const API_SIMPLE_STANDARDS = 'standards/simple';
export const API_SIMPLE_USERS = 'audits/users';
export const API_SIMPLE_ORGANIZATION_USERS = 'organization-units/simple';
export const API_STANDARDS_TYPES__SIMPLE = 'standard-types/simple';
export const API_STANDARDS_TYPES__SYSTEM = 'standard-types/share';
export const API_OBSERVERS = 'users/spectators';
export const API_CREATORS = 'users/created-by';

// WIADOMOŚCI
export const API_MESSAGES = 'crm/messages';
export const API_MESSAGE = 'crm/messages/:id';

// KONTAKTY
export const API_CONTACTS = 'crm/contacts';

// USTAWIENIA
export const API_SETTINGS_COMPANIES = 'companies';
export const API_SETTINGS_COMPANY = 'companies/:id';

export const API_SETTINGS_USERS = 'users';
export const API_SETTINGS_USER = 'users/:id';

export const API_SETTINGS_ORGANIZATIONAL_UNITS = 'organization-units';
export const API_SETTINGS_ORGANIZATIONAL_UNIT = 'organization-units/:id';

export const API_SETTINGS_STANDARDS_TYPES = 'standard-types';
export const API_SETTINGS_STANDARD_TYPE = 'standard-types/:id';

export const API_SETTINGS_STANDARDS = 'standards';
export const API_SETTINGS_STANDARD = 'standards/:id';
export const API_SETTINGS_IMPORT = 'standards/import';

// SUBSKRYPCJE
export const API_SUBSCRIPTIONS = 'subscriptions';
export const API_SUBSCRIPTION = 'subscriptions/:id';
export const API_SUBSCRIPTIONS__LICENSE = 'companies/current-subscription';

// AUDYTY / INSPEKCJE
export const API_AUDITS = 'audits';
export const API_AUDIT = 'audits/:id';
export const API_AUDIT_STANDARDS = API_SIMPLE_STANDARDS;
export const API_AUDIT_CANCEL = 'audits/:id/cancel';
export const API_AUDIT_EXPORT = 'audits/:id/export';
export const API_AUDIT_POINTS_DATA = 'audits/:id/preview'; // Podgląd zakończonego audytu
export const API_AUDIT_START = 'audits/:id/start'; // Rozpoczęcie audytu
export const API_AUDIT_FINISH = 'audits/:id/finish'; // Zakończenie audytu
export const API_AUDIT_POINT_MANAGE = 'audits/:id/audit-points/:pointId';
export const API_AUDIT_POINT_CORRECTION_SENT = 'audits/:id/audit-points/:pointId/correction';
export const API_AUDIT_POINT_CORRECTION_RECEIVED = 'audits/:id/correction';
export const API_AUDIT_SUMMARY_REPORT = 'audits/:auditId/report';
export const API_AUDIT_CALENDAR = 'audits/calendar';
export const API_AUDIT_SUMMARY = 'audits/:id/summary';

// NIEZGODNOŚCI
export const API_NON_CONFORMITIES = 'discrepancies';
export const API_NON_CONFORMITY = 'discrepancies/:id';
export const API_NON_CONFORMITY_CHECKPOINT = 'discrepancies/:id/checkpoints/:checkpointId';
export const API_NON_CONFORMITY_CHECKPOINT_CORRECTION_SEND = 'discrepancies/:id/checkpoints/:checkpointId/correction';

// PLIKI
export const API_FILE = 'files/:id';

// POWIADOMIENIA
export const API_NOTIFICATIONS = 'notifications';
export const API_NOTIFICATION = 'notifications/:id';

// FORMULARZE
export const API_AUDIT_CORRECTION_FORM = 'correction/:token';
export const API_AUDIT_CORRECTION_FORM_CHECK = `${API_AUDIT_CORRECTION_FORM}/check`;
export const API_AUDIT_CORRECTION_FORM_INFO = `${API_AUDIT_CORRECTION_FORM}/info`;
export const API_AUDIT_CORRECTION_FORM_FILE = `${API_AUDIT_CORRECTION_FORM}/file/:id`;

export const API_DISCREPANCIES_CORRECTION_FORM = 'discrepancies/correction/:token';
export const API_DISCREPANCIES_CORRECTION_FORM_CHECK = `${API_DISCREPANCIES_CORRECTION_FORM}/check`;
export const API_DISCREPANCIES_CORRECTION_FORM_INFO = `${API_DISCREPANCIES_CORRECTION_FORM}/info`;
export const API_DISCREPANCIES_CORRECTION_FORM_FILE = `${API_DISCREPANCIES_CORRECTION_FORM}/file/:id`;

// DOSTAWCY
export const API_SUPPLIERS = 'suppliers';
export const API_SUPPLIER = 'suppliers/:id';
export const API_SUPPLIER__EXPORT_MATERIALS_REPORT = 'materials/export';
export const API_SUPPLIER__MAX_EXPOSURE_LEVEL = 'suppliers/:id/max_exposure_level';
export const API_SUPPLIER__RATING_QUALIFICATION_REPORT = 'qualifications/print';
export const API_SUPPLIER__RATING_QUALIFICATION_FORM__GET = 'suppliers/:id/qualifications/:ratingQualificationId';
export const API_SUPPLIER__RATING_QUALIFICATION_FORM__PUT = 'suppliers/:id/qualifications';

// SUROWCE
export const API_MATERIALS = 'materials';
export const API_MATERIAL = 'materials/:id';
export const API_MATERIAL__SUPPLIERS = 'materials/:id/suppliers';
export const API_MATERIAL__EXPORT_MATERIALS_REPORT = 'materials/export';
export const API_MATERIAL__FRAUD_RISK_RATING_FORM__GET = 'materials/:id/risk_assessment/:riskRatingId';
export const API_MATERIAL__FRAUD_RISK_RATING_FORM__SAVE = 'materials/:id/risk_assessment';
export const API_MATERIAL__FRAUD_RISK_RATING_REPORT = 'risk_assessment/print';
export const API_MATERIAL__GENERAL_RISK_RATING_FORM__GET = 'materials/:id/global_risk_assessment/:globalRiskRatingId';
export const API_MATERIAL__GENERAL_RISK_RATING_FORM__SAVE = 'materials/:id/global_risk_assessment';
export const API_MATERIAL__GENERAL_RISK_RATING_REPORT = 'global_risk_assessment/print';
export const API_MATERIAL__IMPORT = 'materials/import';

// MODUŁY
export const API_MODULES = 'modules';

// OCENA RYZYKA
/** Pobranie ilości audytów w danym roku, które musi odbyć dana jednostka organizacyjna */
export const API_ORGANIZATIONAL_UNITS_RISK_NOTE = 'organization-units/audits';

// SLOWNIKI
export const API_DICTIONARIES = 'dictionaries';
export const API_DICTIONARY = 'dictionaries/:dictionaryItemId';
export const API_DICTIONARIES__FORMS = 'dictionaries/forms';
export const API_DICTIONARIES__FORM = 'dictionaries/forms/:formSlug';
export const API_DICTIONARIES__FORM_GROUPS = 'dictionaries/forms/:formId/groups';
export const API_DICTIONARIES__GROUP_ITEMS = 'dictionaries/groups/:groupId';
